<template>
  <div>
    <div class="header-content">
      <div class="logo-part">
        <img src="../assets/logo.png" width="30" height="30" />
        <span>供应商平台</span>
      </div>
    </div>
    <el-form
      ref="AccountForm"
      :model="account"
      :rules="rules"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">欢迎登录</h3>
      <el-form-item prop="username">
        <el-input type="text" v-model="account.username" auto-complete="off" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input
          type="password"
          v-model="account.pwd"
          :autofocus="pwdFocus"
          auto-complete="new-password"
          placeholder="请输入登录密码"
          @keyup.enter.native.prevent="handleLogin"
        ></el-input>
      </el-form-item>
      <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
      <!-- <el-form-item class="extra-text">
        <a href="javascript:;" class="forget-pwd" title="找回密码">忘记密码?</a>
        <router-link :to="{path: '/register'}" class="reg-text" title="立即注册">立即注册</router-link>
      </el-form-item>-->
      <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleLogin"
          :disabled="allowLogin"
          :loading="loading"
        >登录</el-button>
      </el-form-item>
    </el-form>
    <div class="footer">
      <footer-copyright></footer-copyright>
    </div>
  </div>
</template>
<script>
import { Decrypt, Encrypt } from "@/api/untils";
export default {
  data() {
    var validateAccount = (rules, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        if (this.account.username !== "") {
          this.account.username = value;
          this.validateCorrect();
        }
        callback();
      }
    };
    var validatePwd = (rules, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.account.pwd !== "") {
          this.account.pwd = value;
          this.validateCorrect();
        }
        callback();
      }
    };
    return {
      loading: false,
      account: {
        username: "",
        pwd: ""
      },
      rules: {
        username: [
          { required: true, validator: validateAccount, trigger: "change" }
        ],
        pwd: [{ required: true, validator: validatePwd, trigger: "change" }]
      },
      pwdFocus: false,
      allowLogin: true,
      checked: true
    };
  },
  created() {
    let reg_user = JSON.parse(window.sessionStorage.getItem("register-user"));
    if (reg_user) {
      this.account.username = reg_user.username;
      this.account.pwd = "";
      this.pwdFocus = true;
    }
    if (this.$route.query.supplyId && this.$route.query.encryptedStr && this.$route.query.method) {
      // 判断vss过来 是否带了参数
      this.vssAjax();
    }
  },
  methods: {
    handleLogin() {
      var str = "";
      if (this.account.pwd.indexOf("AES-") == 0) {
        str = this.account.pwd;
      } else {
        str = "AES-" + Encrypt(this.account.pwd);
      }

      let para = {
        username: this.account.username,
        password: str,
        mdcKey: "supplierManager" //中台的简称
      };
      this.listLoading = true;

      this.$api.user.login(para).then(res => {
        //	console.log(res.data.map.userObj)

        if (res && res.data.code == "0000") {
          let str = res.data.map.userObj;
          let result = {
            id: str.ptCode,
            nickname: str.ptAlias,
            name: str.ptName,
            email: str.ptEmail,
            ptType: str.ptType
          };

          let token = res.data.map.token;

          if (
            res.data.map.resourcesListB.length == 0 ||
            res.data.map.systemDefineNavi.length == 0
          ) {
            this.$message.error("登录失败，无可用资源");
            this.listLoading = false;
            return;
          }

          sessionStorage.setItem("userInfo", JSON.stringify(result));
          sessionStorage.setItem("token", token);
          // sessionStorage.setItem(
          //   "resourcesList",
          //   JSON.stringify(res.data.map.resourcesListTempRst)
          // ); //资源
          let topList = [
            {
              id: "specialAuction",
              label: "特陈竞价(新)"
            }
          ];
          //  res.data.map.systemDefineNavi = res.data.map.systemDefineNavi.concat(topList);
          sessionStorage.setItem(
            "sys",
            JSON.stringify(res.data.map.systemDefineNavi)
          ); //系统

          let subList = [
            {
              path: "/specialAuction",
              name: "specialAuction",
              component: "/home",
              menuShow: true,
              children: [
                {
                  path: "/specialAuction/specialpurchase/purchaselist",
                  component: "/nav/leftNav",
                  name: "特陈抢购", // 当前路由的name
                  iconCls: "el-icon-sell", // 图标样式class
                  menuShow: true,
                  children: [
                    {
                      path: "/specialAuction/specialpurchase/purchaselist",
                      component: "/specialAuction/specialpurchase/purchaselist",
                      name: "特陈抢购列表",
                      menuShow: true
                    },
                    {
                      path: "/specialAuction/specialpurchase/purchaserecord",
                      component:
                        "/specialAuction/specialpurchase/purchaserecord",
                      name: "购买记录列表",
                      menuShow: true
                    }
                  ]
                }
              ]
            }
          ];
          // res.data.map.resourcesListB = res.data.map.resourcesListB.concat(subList);
          sessionStorage.setItem(
            "menus",
            JSON.stringify(res.data.map.resourcesListB)
          );

          //默认展示的栏目
          this.$router.push({
            path: "/" + res.data.map.systemDefineNavi[0].sysKey
          });

        } else if (res.data.code == "0007") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("登录失败，账号或密码错误");
        }

        this.listLoading = false;
      });
    },
    validateCorrect() {
      if (
        this.account.pwd.trim().length > 0 &&
        this.account.username.trim().length > 0
      ) {
        this.allowLogin = false;
      } else {
        this.allowLogin = true;
      }
    },
    vssAjax() {
      let codestr = this.$route.query.encryptedStr;
      let qstr = '';
      for(let i=0;i<codestr.length;i++){
        if(codestr[i]==" "){
            qstr += '+';
          }else{
            qstr += codestr[i];
          }
        }
      let para = {
        supplyId: this.$route.query.supplyId,  //工号
        encryptedStr: qstr,    //加密串
      };
      this.listLoading = true;
      this.$api.user.loginVss(para).then(res => {
        if (res && res.data.code == "0000") {
          let str = res.data.map.userObj;
          let result = {
            id: str.ptCode,
            nickname: str.ptAlias,
            name: str.ptName,
            email: str.ptEmail,
            ptType: str.ptType
          };

          let token = res.data.map.token;

          if (
            res.data.map.resourcesListB.length == 0 ||
            res.data.map.systemDefineNavi.length == 0
          ) {
            this.$message.error("登录失败，无可用资源");
            this.listLoading = false;
            return;
          }

          sessionStorage.setItem("userInfo", JSON.stringify(result));
          sessionStorage.setItem("token", token);
          sessionStorage.setItem(
            "resourcesList",
            JSON.stringify(res.data.map.resourcesListTempRst)
          ); //资源
          let topList = [
            {
              id: "guestUnity",
              label: "人客合一"
            }
          ];
          //  res.data.map.systemDefineNavi = res.data.map.systemDefineNavi.concat(topList);
          sessionStorage.setItem(
            "sys",
            JSON.stringify(res.data.map.systemDefineNavi)
          ); //系统

          let subList = [
            {
              path: "/specialAuction",
              name: "specialAuction",
              component: "/home",
              menuShow: true,
              children: [
                {
                  path: "/specialAuction/specialpurchase/purchaselist",
                  component: "/nav/leftNav",
                  name: "特陈抢购", // 当前路由的name
                  iconCls: "el-icon-sell", // 图标样式class
                  menuShow: true,
                  children: [
                    {
                      path: "/specialAuction/specialpurchase/purchaselist",
                      component: "/specialAuction/specialpurchase/purchaselist",
                      name: "特陈抢购列表",
                      menuShow: true
                    },
                    {
                      path: "/specialAuction/specialpurchase/purchaserecord",
                      component:
                        "/specialAuction/specialpurchase/purchaserecord",
                      name: "购买记录列表",
                      menuShow: true
                    }
                  ]
                }
              ]
            },
            {
              path: "/guestUnity",
              name: "guestUnity",
              component: "/home",
              menuShow: true,
              children: [
                {
                  path: "/guestUnity/shareShoppers/index",
                  component: "/nav/leftNav",
                  name: "共享采购", // 当前路由的name
                  iconCls: "el-icon-sell", // 图标样式class
                  menuShow: true,
                  children: [
                    {
                      path: "/guestUnity/shareShoppers/index",
                      component: "/guestUnity/shareShoppers/index",
                      name: "销售列表",
                      menuShow: true
                    },
                    {
                      path: "/guestUnity/shareShoppers/salesMonthly",
                      component: "/guestUnity/shareShoppers/salesMonthly",
                      name: "销售列表(月度)",
                      menuShow: true
                    }
                  ]
                }
              ]
            }
          ];
          // res.data.map.resourcesListB = res.data.map.resourcesListB.concat(subList);
          sessionStorage.setItem(
            "menus",
            JSON.stringify(res.data.map.resourcesListB)
          );

          //默认展示的栏目
          // this.$router.push({
          //   path: "/" + res.data.map.systemDefineNavi[0].sysKey
          // });

         let method = this.$route.query.method || '';
          if(method == 'shareShoppers'){
            this.$router.push('/guestUnity/shareShoppers')
          }else if(method == 'salesMonthly'){
            this.$router.push('/guestUnity/shareShoppers/salesMonthly')
          }else if(method == 'contract'){
            this.$router.push('/contractManager/purchasecontract')
          }else if(method == 'specialAuction'){
            this.$router.push('/specialAuction/specialpurchase/purchaselist')
          }
          else if(method == '' || method == null || method == undefined){
          //默认展示的栏目
            this.$router.push({
              path: "/" + JSON.parse(sessionStorage.sys)[0].sysKey
            });
          }
        } else if (res.data.code == "0007") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("登录失败，账号或密码错误");
        }
        this.listLoading = false;
      });
    }
  }
};
</script>
<style scoped>
body {
  background: #dfe9fb;
}
.header-content {
  position: fixed;
  top: 0;
  width: 100%;
  height: 50px;
  padding: 6px 0;
  border-bottom: 1px solid #ddd;
  box-shadow: 0 0 2px #ddd;
}
.header-content .logo-part {
  margin-left: 10px;
  font-size: 18px;
  color: #999;
}
.header-content .logo-part img {
  vertical-align: middle;
}
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 160px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  background: -ms-linear-gradient(top, #ace, #00c1de); /* IE 10 */
  background: -moz-linear-gradient(top, #ace, #00c1de); /*火狐*/
  background: -webkit-gradient(
    linear,
    0% 0%,
    0% 100%,
    from(#ace),
    to(#00c1de)
  ); /*谷歌*/
  background: -webkit-linear-gradient(
    top,
    #ace,
    #00c1de
  ); /*Safari5.1 Chrome 10+*/
  background: -o-linear-gradient(top, #ace, #00c1de); /*Opera 11.10+*/
}
.login-container .title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.login-container .remember {
  margin: 0px 0px 35px 0px;
}
.extra-text {
  position: relative;
  margin-bottom: 0;
  padding-left: 2px;
}
.extra-text a {
  font-size: 12px;
  color: #aaa;
}
.extra-text a:hover {
  color: #29e;
}
.extra-text .reg-text {
  position: absolute;
  top: 4px;
  right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue